import React from "react";

interface Props {
  /** Defaults to the Zeitmanagement wording, which is where both current callers live. */
  children?: React.ReactNode;
  className?: string;
}

/**
 * The banner above a form that is rendered for looking at rather than editing.
 *
 * Shared because "read-only" has to look the same wherever it turns up: the worker's own
 * Zeitmanagement entry and the manager-side one are the same screen to a user, and a second
 * hand-written copy of this markup is how they stop being.
 */
export const ReadOnlyNotice: React.FC<Props> = ({
  children = "Nur Lesezugriff — dieser Eintrag kann nicht bearbeitet werden",
  className,
}) => (
  // No `role="status"`: it is static page furniture, not something that gets announced when it
  // appears, and `Loader` already owns that role on these screens.
  <div
    className={`mb-4 flex items-center gap-2 rounded-xl bg-blue-50 px-4 py-3 text-sm text-[#16499A] ${className ?? ""}`}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    {children}
  </div>
);
